/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Status_CompleteInputs */



/**
* | output |
* | --- |
* | "Media import complete." |
*
* @param {Media_Import_Status_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_status_complete = /** @type {((inputs?: Media_Import_Status_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Status_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation des medias terminee.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medienimport abgeschlossen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione multimediale completata.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт медиафайлов завершен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación de medios completada.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("媒体导入完成。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアのインポートが完了しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया आयात पूर्ण हो गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação de mídia concluída.")
	return /** @type {LocalizedString} */ ("Media import complete.")
});